export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  WARN: "ALERT_WARNING",
  INFO: "ALERT_INFO",
  CLEAR: "ALERT_CLEAR"
};
